export default "__VITE_ASSET__DrBAvFF7__"